import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './arrow-button.scss';

const ArrowButton = ({ arrowText, onButtonClick }) => (
	<div className={css.component} tabIndex={0} role="button" onClick={onButtonClick}> {arrowText} </div>
);

ArrowButton.propTypes = {
    arrowText: PropTypes.string,
    onButtonClick: PropTypes.func
};

export default ArrowButton;
